import { GET_AC_TAGS } from '../types/index';

export default (tags = [], action) => {
  switch (action.type) {
    case GET_AC_TAGS:
      return action.payload;
    default:
      return tags;
  }
}